import React from 'react';
import FiltersProvider from 'providers/FiltersProvider';
import NavbarSearchInput from './NavbarSearchInput';
import NavbarSearchTrigger from './NavbarSearchTrigger';
import { isCordova } from 'utils/platform';

const CSS = require('./NavbarSearch.less');

interface NavbarSearchProps {
  isHost: boolean;
  isMobile: boolean;
}

function NavbarSearch({ isHost, isMobile }: NavbarSearchProps) {
  if (isHost && isMobile && !isCordova()) {
    return null;
  }

  return (
    <div className={CSS.NavbarSearch}>
      <FiltersProvider>
        {({ filters }) =>
          <>
            {isMobile ?
              <NavbarSearchTrigger city={filters.city} country={filters.country} /> :
              <NavbarSearchInput filters={filters} />
            }
          </>
        }
      </FiltersProvider>
    </div>
  );
}

export default NavbarSearch;
